import sessionManager from './sessionManager';
import loginUser from './loginUser';
import fetchMainCollection from './fetchMainCollection';

export default [loginUser, sessionManager, fetchMainCollection];
